import { render } from "./ExportAll.vue?vue&type=template&id=5265098d"
import script from "./ExportAll.vue?vue&type=script&lang=js"
export * from "./ExportAll.vue?vue&type=script&lang=js"
script.render = render

export default script